import { AvatarGroup } from '@mui/material';
import React from 'react';

import { CenterCellContainer } from './CenterCellContainer';
import { ExamAvatar } from './ExamAvatar';
import { EXAM_ICON_NAMES } from 'FRONTEND/utils/constants';

export const CellExamIcons = ({ exams }: { exams: string[] }) => {
  const iconsToShow = exams.filter(exam => EXAM_ICON_NAMES.includes(exam));

  if (iconsToShow.length === 0) {
    return null;
  }

  return (
    <CenterCellContainer>
      <AvatarGroup max={iconsToShow.length}>
        {iconsToShow.map((icon) => (
          <ExamAvatar key={icon} icon={icon} />
        ))}
      </AvatarGroup>
    </CenterCellContainer>
  );
};
